import http from 'plugins/axios';

export default {
  getAuditList(query) {
    return http.post({
      url: '/la/admin/authRecord/search',
      data: {
        type: 0,
        ...query
      },
      dataType: 'form'
    });
  },
  getCountryCodeList() {
    return http.get({ url: '/la/admin/countryCodeList' });
  },
  approveAudit({ id, backReason, status }) {
    return http.post({
      url: '/la/admin/authRecord/update',
      data: {
        id,
        backReason,
        status
      },
      dataType: 'form'
    });
  },
  getAuditDetail(id) {
    return http.get({
      url: `/la/admin/authRecord/detail/${id}`
    });
  },
  getoldDetail(id) {
    return http.get({
      url: `/la/admin/authRecord/detail/oldUser/${id}`
    });
  },
  getExcel(data) {
    return http.get({
      url: '/la/admin/authRecord/export',
      responseType: 'blob',
      data,
      // header:{
      //   Authorization:Cookies.get('admin-token')
      // }
    });
  },
  getIdOK(data) {
    return http.post({
      url: '/la/admin/authRecord/search/oldUser',
      data,
      dataType: 'form'
    });
  },
  RollBack(data) {
    return http.post({
      url: '/la/admin/authRecord/roll/back',
      data,
      dataType: 'form'
    });
  },
  delApi(data) {
    return http.post({
      url: '/la/admin/authRecord/delete',
      data,
      dataType: 'form'
    });
  }
};
